import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { selectProductJobScheduleByGuid } from '../../../store/selectors/jobSchedulesSelectors'
import { showModal } from '../../../store/actions/modalActions'
import { ModalTypes } from '../../../types/modals'
import { updateProductJobSchedule } from '../../../store/async-thunks/schedules/updateProductJobSchedule'
import { fetchProductJobSchedule } from '../../../store/async-thunks/schedules/fetchProductJobSchedule'

interface ScheduleSaveResetProps {
    guid: string
    isInvalid: boolean
}

export const ScheduleSaveReset = (props: ScheduleSaveResetProps) => {
    const { guid, isInvalid } = props
    const dispatch = useAppDispatch()
    const productSchedules = useAppSelector(
        selectProductJobScheduleByGuid(guid)
    )

    const handleSave = () =>
        dispatch(
            updateProductJobSchedule({
                productId: guid,
                schedule: productSchedules,
            })
        )

    const reset = () => dispatch(fetchProductJobSchedule({ productId: guid }))

    const handleReset = () =>
        dispatch(
            showModal(ModalTypes.MAIN_MODAL, {
                body: `Reset all changes ?`,
                onSubmit: reset,
            })
        )

    return (
        <div className="d-flex gap-2 mb-4">
            <button
                className="app-btn-main app-btn-apply"
                onClick={handleReset}
            >
                Reset
            </button>
            <button
                className="app-btn-main app-btn-reset"
                onClick={handleSave}
                disabled={isInvalid}
            >
                Save
            </button>
        </div>
    )
}
